module.exports = __webpack_public_path__ + "static/media/thumbnail.79471322.jpg";